import { nsHistorics } from '@/app/i18n/namespaces';
import SIM_CARDS_STATUS from '../../sims/enums/SimCardStatus';
import SUBSCRIPTION_STATUS from '../../subscriptions/enums/SubscriptionStatus';
import POS_TERMINAL_STATUS from '../../terminals/enums/PosTerminalStatus';
import USER_STATUS from '../../users/monetic/enums/UserStatus';
import HISTORICS_VALUE_TYPE from './HistoricsValueType';


/**
 * Represents an object containing objects of action types.
 * @typedef {object} HISTORICS_ACTION_TYPE
 * @property {object<string, ActionType>} ActionType- The action type object.
 */

/**
 * Represents the object of action type.
 * @typedef {object} ActionType
 * @property {string} name- The name of the action.
 * @property {string} entity- The name of the entity.
 * @property {string} type- The type of value to show (text,date,badge...).
 * @property {Array} dataKeys- The keys of actions values if it's an object.
 * @property {Array} valuesList- The list of possible values to display.
 * @property {Array} subTitle- The subtitle to display in détails modal.
 */

const HISTORICS_ACTION_TYPE = {
    SIM_CARDS: {
        UPDATE_SIM_LABEL: {
            name: 'UPDATE_SIM_LABEL',
            entity: 'actions.sim_cards.UPDATE_SIM_LABEL',
            type: HISTORICS_VALUE_TYPE.TEXT.name,
            dataKeys: ['label'],
            valuesList: null,
            namespace: nsHistorics
        },
        UPDATE_SIM_OFFER: {
            name: 'UPDATE_SIM_OFFER',
            entity: 'actions.sim_cards.UPDATE_SIM_OFFER',
            type: HISTORICS_VALUE_TYPE.TEXT.name,
            dataKeys: ['displayName'],
            valuesList: null,
            namespace: nsHistorics
        },
        ACTIVATE_SIM: {
            name: 'ACTIVATE_SIM',
            entity: 'actions.sim_cards.ACTIVATE_SIM',
            type: HISTORICS_VALUE_TYPE.BADGE.name,
            dataKeys: ['status'],
            valuesList: SIM_CARDS_STATUS,
            namespace: nsHistorics
        },
        REACTIVATE_SIM: {
            name: 'REACTIVATE_SIM',
            entity: 'actions.sim_cards.REACTIVATE_SIM',
            type: HISTORICS_VALUE_TYPE.BADGE.name,
            dataKeys: ['status'],
            valuesList: SIM_CARDS_STATUS,
            namespace: nsHistorics
        },
        SUSPEND_SIM: {
            name: 'SUSPEND_SIM',
            entity: 'actions.sim_cards.SUSPEND_SIM',
            type: HISTORICS_VALUE_TYPE.BADGE.name,
            dataKeys: ['status'],
            valuesList: SIM_CARDS_STATUS,
            namespace: nsHistorics
        },
        TERMINATE_SIM: {
            name: 'TERMINATE_SIM',
            entity: 'actions.sim_cards.TERMINATE_SIM',
            type: HISTORICS_VALUE_TYPE.BADGE.name,
            dataKeys: ['status'],
            valuesList: SIM_CARDS_STATUS,
            namespace: nsHistorics
        },
        DISSOCIATE_POS_TERMINAL: {
            name: 'DISSOCIATE_POS_TERMINAL',
            entity: 'actions.sim_cards.DISSOCIATE_POS_TERMINAL',
            type: HISTORICS_VALUE_TYPE.TEXT.name,
            dataKeys: ['serialNumber'],
            valuesList: null,
            namespace: nsHistorics
        },
        ASSOCIATE_POS_TERMINAL: {
            name: 'ASSOCIATE_POS_TERMINAL',
            entity: 'actions.sim_cards.ASSOCIATE_POS_TERMINAL',
            type: HISTORICS_VALUE_TYPE.TEXT.name,
            dataKeys: ['serialNumber'],
            valuesList: null,
            namespace: nsHistorics
        },
        ASK_REPLACE_SIM: {
            name: 'ASK_REPLACE_SIM',
            entity: 'actions.sim_cards.ASK_REPLACE_SIM',
            type: HISTORICS_VALUE_TYPE.BADGE.name,
            dataKeys: ['status', 'iccid'],
            valuesList: null,
            namespace: nsHistorics
        },
        SIM_REPLACE: {
            name: 'SIM_REPLACE',
            entity: 'actions.sim_cards.SIM_REPLACE',
            type: HISTORICS_VALUE_TYPE.BADGE.name,
            dataKeys: ['status', 'iccid'],
            valuesList: null,
            namespace: nsHistorics
        }
    },
    POS_TERMINALS: {
        POSTERMINAL_IP_SUBSCRIPTION_ACTIVATION: {
            name: 'POSTERMINAL_IP_SUBSCRIPTION_ACTIVATION',
            entity: 'actions.pos_terminals.IP_SUBSCRIPTION_ACTIVATION',
            type: HISTORICS_VALUE_TYPE.BADGE.name,
            dataKeys: ['status', 'iccid'],
            valuesList: SUBSCRIPTION_STATUS,
            namespace: nsHistorics
        },
        POSTERMINAL_IP_SUBSCRIPTION_MULTIPLE_ACTIVATION: {
            name: 'POSTERMINAL_IP_SUBSCRIPTION_MULTIPLE_ACTIVATION',
            entity: 'actions.pos_terminals.IP_SUBSCRIPTION_MULTIPLE_ACTIVATION',
            type: HISTORICS_VALUE_TYPE.TEXT.name,
            namespace: nsHistorics
        },
        POSTERMINAL_IP_SUBSCRIPTION_TERMINATE: {
            name: 'POSTERMINAL_IP_SUBSCRIPTION_TERMINATE',
            entity: 'actions.pos_terminals.IP_SUBSCRIPTION_TERMINATE',
            type: HISTORICS_VALUE_TYPE.BADGE.name,
            dataKeys: ['status'],
            valuesList: SUBSCRIPTION_STATUS,
            namespace: nsHistorics
        },
        POSTERMINAL_REWAREHOUSE: {
            name: 'POSTERMINAL_REWAREHOUSE',
            entity: 'actions.pos_terminals.REWAREHOUSE',
            type: HISTORICS_VALUE_TYPE.BADGE.name,
            dataKeys: ['status'],
            valuesList: SUBSCRIPTION_STATUS,
            namespace: nsHistorics
        },
        POSTERMINAL_MIGRATE: {
            name: 'POSTERMINAL_MIGRATE',
            entity: 'actions.pos_terminals.MIGRATE',
            type: HISTORICS_VALUE_TYPE.DATE.name,
            dataKeys: ['startBillingDate'],
            valuesList: null,
            namespace: nsHistorics
        },
        POSTERMINAL_BLACKLIST_ADD: {
            name: 'POSTERMINAL_BLACKLIST_ADD',
            entity: 'actions.pos_terminals.BLACKLIST_ADD',
            type: HISTORICS_VALUE_TYPE.BADGE.name,
            dataKeys: ['status'],
            valuesList: POS_TERMINAL_STATUS,
            namespace: nsHistorics
        },
        POSTERMINAL_BLACKLIST_ADD_MULTIPLE: {
            name: 'POSTERMINAL_BLACKLIST_ADD_MULTIPLE',
            entity: 'actions.pos_terminals.BLACKLIST_ADD_MULTIPLE',
            type: HISTORICS_VALUE_TYPE.TEXT.name,
            namespace: nsHistorics
        },
        POSTERMINAL_BLACKLIST_REMOVE: {
            name: 'POSTERMINAL_BLACKLIST_REMOVE',
            entity: 'actions.pos_terminals.BLACKLIST_REMOVE',
            type: HISTORICS_VALUE_TYPE.BADGE.name,
            dataKeys: ['status'],
            valuesList: POS_TERMINAL_STATUS,
            namespace: nsHistorics
        },
        POSTERMINAL_BLACKLIST_ADD_TEMPORARY: {
            name: 'POSTERMINAL_BLACKLIST_ADD_TEMPORARY',
            entity: 'actions.pos_terminals.BLACKLIST_ADD_TEMPORARY',
            type: HISTORICS_VALUE_TYPE.BADGE.name,
            dataKeys: ['status'],
            valuesList: POS_TERMINAL_STATUS,
            namespace: nsHistorics
        },
        POSTERMINAL_LABEL_UPDATE: {
            name: 'POSTERMINAL_LABEL_UPDATE',
            entity: 'actions.pos_terminals.LABEL_UPDATE',
            type: HISTORICS_VALUE_TYPE.MULTI_VALUES.name,
            dataKeys: ['label', 'customLabel'],
            valuesList: null,
            namespace: nsHistorics
        },
        DISSOCIATE_SIM: {
            name: 'DISSOCIATE_SIM',
            entity: 'actions.pos_terminals.DISSOCIATE_SIM',
            type: HISTORICS_VALUE_TYPE.TEXT.name,
            dataKeys: ['iccid'],
            valuesList: null,
            namespace: nsHistorics
        },
        ASSOCIATE_SIM: {
            name: 'ASSOCIATE_SIM',
            entity: 'actions.pos_terminals.ASSOCIATE_SIM',
            type: HISTORICS_VALUE_TYPE.TEXT.name,
            dataKeys: ['iccid'],
            valuesList: null,
            namespace: nsHistorics
        },
        UPDATE_IP_OFFER: {
            name: 'UPDATE_IP_OFFER',
            entity: 'actions.pos_terminals.UPDATE_IP_OFFER',
            type: HISTORICS_VALUE_TYPE.TEXT.name,
            dataKeys: ['label'],
            valuesList: null,
            namespace: nsHistorics
        }
    },
    USERS: {
        MANAGEMENT_USER_CREATION: {
            name: 'MANAGEMENT_USER_CREATION',
            entity: 'actions.users.MANAGEMENT_USER_CREATION',
            type: HISTORICS_VALUE_TYPE.TEXT.name,
            dataKeys: ['users'],
            valuesList: null,
            namespace: nsHistorics
        },
        MERCHANT_USER_CREATION: {
            name: 'MERCHANT_USER_CREATION',
            entity: 'actions.users.MERCHANT_USER_CREATION',
            type: HISTORICS_VALUE_TYPE.TEXT.name,
            dataKeys: ['users'],
            valuesList: null,
            namespace: nsHistorics
        },
        USER_LOGIN_AS: {
            name: 'USER_LOGIN_AS',
            entity: 'actions.users.USER_LOGIN_AS',
            type: HISTORICS_VALUE_TYPE.TEXT.name,
            dataKeys: ['email'],
            valuesList: SUBSCRIPTION_STATUS,
            namespace: nsHistorics
        },
        USER_PERMISSIONS: {
            name: 'USER_PERMISSIONS',
            entity: 'actions.users.USER_PERMISSIONS',
            type: HISTORICS_VALUE_TYPE.LIST.name,
            dataKeys: ['permissions'],
            valuesList: null,
            hideInitialDetail: true,
            namespace: nsHistorics
        },
        USER_ACTIVATION: {
            name: 'USER_ACTIVATION',
            entity: 'actions.users.USER_ACTIVATION',
            type: HISTORICS_VALUE_TYPE.BADGE.name,
            dataKeys: ['status'],
            valuesList: USER_STATUS,
            namespace: nsHistorics
        },
        USER_DEACTIVATION: {
            name: 'USER_DEACTIVATION',
            entity: 'actions.users.USER_DEACTIVATION',
            type: HISTORICS_VALUE_TYPE.BADGE.name,
            dataKeys: ['status'],
            valuesList: USER_STATUS,
            namespace: nsHistorics
        },
        USER_REMOVAL: {
            name: 'USER_REMOVAL',
            entity: 'actions.users.USER_REMOVAL',
            type: HISTORICS_VALUE_TYPE.TEXT.name,
            dataKeys: ['email'],
            valuesList: null,
            namespace: nsHistorics
        },
        USER_EMAIL_ACTIVATION_RESENDING: {
            name: 'USER_EMAIL_ACTIVATION_RESENDING',
            entity: 'actions.users.USER_EMAIL_ACTIVATION_RESENDING',
            type: HISTORICS_VALUE_TYPE.TEXT.name,
            dataKeys: ['email'],
            valuesList: null,
            namespace: nsHistorics
        }
    }
};

// Extract key from HISTORICS_ACTION_TYPE object
const extractHistoricsActionsKeys = () => {
    const actionKeys = {};
    Object.keys(HISTORICS_ACTION_TYPE).forEach(key => {
        actionKeys[key] = key;
    });
    return actionKeys;
};

const ACTIONS_KEYS = extractHistoricsActionsKeys();

export { ACTIONS_KEYS };
export default HISTORICS_ACTION_TYPE;